import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { StateManagementService } from '../../services/statemanagement/statemanagement.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'conversion-signout',
  template: `
    <div class="signout-container">
      <h3>You have signed out.</h3>
    </div>
  `,
  styles: [
    `
      .signout-container {
        min-height: 50vh;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `,
  ],
})
export class SignOutComponent {
  constructor(
    private readonly oauthService: OAuthService,
    private readonly stateManagementService: StateManagementService
  ) {}

  ngOnInit(): void {
    this.stateManagementService.clearRouteBeforeLogin();

    if (this.oauthService.hasValidAccessToken() || this.oauthService.hasValidIdToken()) {
      this.oauthService.logOut();
    }
  }
}